/* eslint-disable */
import React, { Component, RefObject } from 'react';
import MUIDataTable, {
  MUIDataTableOptions,
  MUIDataTableProps,
  MUIDataTableState,
  MUIDataTableTextLabels,
} from 'mui-datatables';
import i18n from '../../pages/i18n';

const arabicLocalization: MUIDataTableTextLabels = {
  body: {
    noMatch: 'عذرًا، لا توجد بيانات متطابقة',
    toolTip: 'ترتيب',
  },
  pagination: {
    next: 'التالي',
    previous: 'السابق',
    rowsPerPage: 'عدد الصفوف لكل صفحة',
    displayRows: 'من',
  },
  toolbar: {
    search: 'بحث',
    downloadCsv: 'تحميل CSV',
    print: 'طباعة',
    viewColumns: 'عرض الأعمدة',
    filterTable: 'تصفية الجدول',
  },
  filter: {
    all: 'الكل',
    title: 'فلاتر',
    reset: 'إعادة تعيين',
  },
  viewColumns: {
    title: 'عرض الأعمدة',
    titleAria: 'إظهار/إخفاء الأعمدة',
  },
  selectedRows: {
    text: 'صفوف محددة',
    delete: 'حذف',
    deleteAria: 'حذف الصفوف المحددة',
  },
};

const options: MUIDataTableOptions = {
  search: false,
  download: false,
  print: false,
  viewColumns: false,
  elevation: 0,
  filter: false,
  selectableRowsHeader: false,
  selectableRows: 'none',
  page: 0,
  textLabels: i18n.language === 'ar' ? arabicLocalization : {},
};

const pagination_list = {
  grid: [6, 12, 30, 100],
  table: [10, 15, 50, 100],
};

interface TableProps {
  columns?: any[];
  data?: any[];
  count?: number;
  options?: MUIDataTableOptions;
  hidePagination?: boolean;
  customRef?: RefObject<
    Component<MUIDataTableProps, MUIDataTableState, any>
  > | null;
}

export default function Table({
  columns = [],
  data = [],
  count,
  options: customOptions,
  hidePagination = false,
  customRef,
}: TableProps) {
  return (
    <MUIDataTable
      title=""
      innerRef={customRef || undefined}
      columns={columns}
      data={data}
      options={{
        ...options,
        serverSide: true,
        pagination: !hidePagination,
        count,
        sort: false,
        rowsPerPageOptions: pagination_list.table,
        ...customOptions,
      }}
    />
  );
}
